module.exports = __webpack_public_path__ + "img/new_footer_qrcode2.04dd8a8a.png";